module.exports = __webpack_public_path__ + "img/calendar-empty.ed094add.png";